import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import criSubCategory from './criSubCategory';
import controller from './cri-category.controller';
import directive from './cri-category.directive';


export default angular.module('app.components.advisory.ecat.criCategory', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  criSubCategory,
])
  .directive('ecatCriCategory', directive)
  .controller('CRICategoryController', controller)
  .name;

console.log('app.components.advisory.ecat.criCategory created');
